import Web3 from 'web3';

export const formatAddress = (address: string): string => {
  try {
    const web3 = new Web3();
    if (web3.utils.toChecksumAddress(String(address).toLowerCase())) {
      return `${address.substring(0, 4)}...${address.substring(address.length - 4)}`;
    }
    return address;
  } catch (e) {
    if (e instanceof Error) {
      return address;
    } 
    return address;
  }
};